import styled, { css } from 'styled-components';

const Hero = css`
  width: auto;
  height: inherit;
`;

export const HeroStyled = styled('img')`
  ${Hero}
`;
